<template>
  <div class="container-fluid">
    <b-card>
      <div class="row mb-3">
        <div class="col-lg-1 text-center">
          <b-button variant="dark" type="submit" class="btn" @click="confirmationDialog('save')">
            <font-awesome-icon :icon="['fa', 'save']" class="fontIconBtn"/>
            <span class="fontButt"><b> Guardar </b></span>
          </b-button>
        </div>
        <div class="col-lg-2 text-center">
          <b-button type="submit" class="" variant="warning" @click="showEnterprises = !showEnterprises">
            <font-awesome-icon v-if="showEnterprises" :icon="['fa', 'store-alt-slash']" class="fontIconBtn"/>
            <font-awesome-icon v-if="!showEnterprises" :icon="['fa', 'store']" class="fontIconBtn"/>
            <span class="fontButt"><b>{{!showEnterprises ? ' Mostrar' : ' Ocultar'}} otras sucursales</b></span>
          </b-button>
        </div>
        <div class="col-lg-2 text-center">
          <b-button type="submit" class="btn" variant="primary" @click="setFaltantes(`grid`)">
            <font-awesome-icon :icon="['fa', 'eye-slash']" class="fontIconBtn"/><br/>
            <span class="fontButt"><b>Marcar faltante</b></span>
          </b-button>
        </div>
        <div class="col-lg-2 text-center">
          <b-button type="submit" class="btn" variant="danger" @click="deleteRegister(`grid`)">
            <font-awesome-icon :icon="['fa', 'trash']" class="fontIconBtn"/><br/>
            <span class=" fontButt"><b>Eliminar registro</b></span>
          </b-button>
        </div>
        <div class="col-lg-2 text-center">
          <b-button type="submit" class="btn" variant="success" @click="confirmationDialog('cargarCompras')">
            <font-awesome-icon :icon="['fa', 'money-check-alt']" class="fontIconBtn"/><br/>
            <span class="fontButt"><b>Cargar compra</b></span>
          </b-button>
        </div>
        <div class="col-lg-2 text-center m-1">
          <b-button type="submit" class="btn" variant="info" @click="confirmChangeProvider()">
            <font-awesome-icon :icon="['fa', 'money-check-alt']" class="fontIconBtn"/><br/>
            <span class="fontButt"><b>Cambiar de Proveedor</b></span>
          </b-button>
        </div>
      </div>

      <div class="col-lg-12 text-center mt-5 mb-2">
        <span><h2><b>{{nameMarca}}</b></h2></span>
        <span><h5><b>Total de Compra $ {{generalCost}}</b></h5></span>
      </div>
      <div class="row">
        <b><h4>Folio: # {{ nextTicket }}</h4></b>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <h6>Dia de compra</h6>
          <input type="date" v-model="today">
        </div>
      </div>

      <div>
        <b-card header="Sucursales" header-tag="header" title="Seleccione las sucursales que quiera ver." v-if="showEnterprises">
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              v-model="selected"
              :options="options"
              :aria-describedby="ariaDescribedby"
              plain
              size="lg"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-card>

        <b-card no-body class="mt-2">
          <b-tabs v-model="tabIndex" card @input="onTabChange">
            <b-tab
              :title="enterprise.name"
              v-for="(enterprise, index) in enterprises"
              :key="index"
              :title-link-class="linkClass(index)"
            >
              <h5>{{enterprise.name}}</h5>
              <b-button type="submit" class="btn col-lg-2 mb-3" variant="success" @click="addRow(enterprise)">
                <font-awesome-icon :icon="['fa', 'plus']" class="fontIconBtn"/>
              </b-button>
              <br>
              <b-button
                type="submit" class="btn col-lg-4 mb-3" variant="info"
                @click="copyElements(`grid${enterprise.id}`)"
                v-if="user.enterprise_id !== enterprise.id"
                alt="Copiar elementos seleccionados a la sucursal original"
              >
                <font-awesome-icon :icon="['fa', 'copy']" class="fontIconBtn"/>
                <span class="ml-3 fontButt"><b>Copiar elementos seleccionados</b></span>
              </b-button>

              <!-- Grid por empresa (showEnterprises = true) -->
              <vue-excel-editor
                v-if="showEnterprises"
                :ref="`grid${enterprise.id}`"
                :cell-style='mystyle'
                v-model="dataEnterprises[enterprise.id]"
                no-paging
                filter-row
              >
                <vue-excel-column field="id_client"                   type="number"  label="Id Cliente"      width="70px"  textTransform="uppercase" :change="changeClient" />
                <vue-excel-column field="fullname"                                   label="Cliente"          width="240px" textTransform="uppercase" readonly/>
                <vue-excel-column field="catalogo"                                   label="Catalogo"         width="120px" textTransform="uppercase"/>
                <vue-excel-column field="marca"                                      label="Marca"            width="120px" textTransform="uppercase"/>
                <vue-excel-column field="modelo"                                     label="Modelo"           width="80px"  textTransform="uppercase"/>
                <vue-excel-column field="color"                                      label="Color"            width="80px"  textTransform="uppercase"/>
                <vue-excel-column field="numero"                                     label="Talla"            width="80px"  textTransform="uppercase"/>
                <vue-excel-column field="precio"                       type="number" label="Precio Cliente"   width="80px"  :change="changeCost"/>
                <vue-excel-column field="porcentaje_descuento"         type="number" label="% Desc Cliente"   width="60px"  :change="changeDiscount"/>
                <vue-excel-column field="venta"                                      label="Costo Cliente"    width="80px"  :change="changeClientPrice"/>
                <vue-excel-column field="porcentaje_descuento_nosotros" type="number" label="% Nosotros"      width="80px"  :change="changeDiscountAbout"/>
                <vue-excel-column field="costo_tienda"                 type="number" label="Costo Tienda"     width="80px"  :change="changeCostoTienda"/>
                <vue-excel-column field="comentario"                                 label="Comentarios"/>
                <vue-excel-column field="campo_muerto"                               label="Texto abierto"/>
                <vue-excel-column field="delivery_date"                              label="Fecha"            width="120px"/>
              </vue-excel-editor>

              <!-- Grid general (showEnterprises = false) -->
              <template v-if="!showEnterprises">
                <button @click="exportAsExcel('grid')"> Export Excel </button>
                <button @click="exportAsCsv('grid')"> Export CSV </button>
                <vue-excel-editor
                  ref="grid"
                  :cell-style='mystyle'
                  v-model="jsondata"
                  :localized-label="myLabels"
                  no-paging
                  filter-row
                >
                  <vue-excel-column field="id_client"                    type="number"  label="Id Cliente"     width="70px"  textTransform="uppercase" :change="changeClient" key-field/>
                  <vue-excel-column field="fullname"                                    label="Cliente"         width="240px" textTransform="uppercase" readonly/>
                  <vue-excel-column field="catalogo"                                    label="Catalogo"        width="120px" textTransform="uppercase"/>
                  <vue-excel-column field="marca"                                       label="Marca"           width="120px" textTransform="uppercase"/>
                  <vue-excel-column field="modelo"                                      label="Modelo"          width="80px"  textTransform="uppercase"/>
                  <vue-excel-column field="color"                                       label="Color"           width="80px"  textTransform="uppercase"/>
                  <vue-excel-column field="numero"                                      label="Talla"           width="80px"  textTransform="uppercase"/>
                  <vue-excel-column field="precio"                        type="number" label="Precio Cliente"  width="80px"  :change="changeCost"/>
                  <vue-excel-column field="porcentaje_descuento"          type="number" label="% Desc Cliente"  width="60px"  :change="changeDiscount"/>
                  <vue-excel-column field="venta"                                       label="Costo Cliente"   width="80px"  :change="changeClientPrice"/>
                  <vue-excel-column field="porcentaje_descuento_nosotros" type="number" label="% Nosotros"      width="80px"  :change="changeDiscountAbout"/>
                  <vue-excel-column field="costo_tienda"                  type="number" label="Costo Tienda"    width="80px"  :change="changeCostoTienda"/>
                  <vue-excel-column field="comentario"                                  label="Comentarios"/>
                  <vue-excel-column field="campo_muerto"                                label="Texto abierto"/>
                  <vue-excel-column field="delivery_date"                               label="Fecha"           width="120px"/>
                </vue-excel-editor>
              </template>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-card>

    <modal name="providerCahnge" :scrollable="true" height="300" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('providerCahnge')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="body">
        <div class="row justify-content-center">
          <h4>CAMBIO DE PROVEEDOR</h4>
        </div>
        <div class="row justify-content-center" v-if="rowsSelected.length > 0">
          <h5 class="text-center"><b>CANTIDAD DE FILAS SELECCIONADAS {{ rowsSelected.length }}</b></h5>
          <select name="" class="form-control col-8 mt-2" id="" v-model="providerSelected">
            <option value="null">SELECCIONE UNA OPCIÓN</option>
            <option :value="p.id_provider" v-for="p in providers" :key="p.id_provider">{{ p.name }}</option>
          </select>
          <div class="col-12 text-center mt-2">
            <button class="btn btn-success mt-3" @click="changeProvider">Realizar el cambio</button>
          </div>
        </div>
        <div class="row justify-content-center" v-else>
          <span style="color: red; font-size: 18px;"><b>SELECCIONE POR LO MENOS UN ELEMENTO</b></span>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import formatData from '@/mixins/formatAxios'
import { BButton, BCard, BTabs, BTab, BFormCheckboxGroup, BFormGroup } from 'bootstrap-vue'
import moment from 'moment'
moment.locale('es')

export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    BButton,
    BCard,
    BTabs,
    BTab,
    BFormCheckboxGroup,
    BFormGroup
  },
  data () {
    return {
      myLabels: {
        footerLeft: (top, bottom, total) => `Record ${top} to ${bottom} of ${total}`,
        first: 'First',
        previous: 'Previous',
        next: 'Next',
        last: 'Last',
        footerRight: { selected: 'Selected:', filtered: 'Filtered:', loaded: 'Loaded:' },
        processing: 'Processing',
        tableSetting: 'Table Setting',
        exportExcel: 'Export Excel',
        importExcel: 'Import Excel',
        back: 'Back',
        reset: 'Default',
        sortingAndFiltering: 'Sorting And Filtering',
        sortAscending: 'Sort Ascending',
        sortDescending: 'Sort Descending',
        near: '≒ Near',
        exactMatch: '= Exact Match',
        notMatch: '≠ Not Match',
        greaterThan: '> Greater Than',
        greaterThanOrEqualTo: '≥ Greater Than or Equal To',
        lessThan: '< Less Than',
        lessThanOrEqualTo: '≤ Less Than Or Equal To',
        regularExpression: '~ Regular Expression',
        customFilter: 'Custom Filter',
        listFirstNValuesOnly: n => `List first ${n} values only`,
        apply: 'Apply',
        noRecordIsRead: 'No record is read',
        readonlyColumnDetected: 'Readonly column detected',
        columnHasValidationError: (name, err) => `Column ${name} has validation error: ${err}`,
        noMatchedColumnName: 'No matched column name',
        invalidInputValue: 'Invalid input value',
        missingKeyColumn: 'Missing key column',
        noRecordIndicator: 'No record'
      },
      today: moment().format('YYYY-MM-DD'),
      showEnterprises: false,
      selected: [],
      options: [],
      tabIndex: 0,
      generalCost: 0,
      id_provider: 0,
      nameMarca: '',
      rows: [],
      isLoading: false,
      jsondata: [],
      optionsMarca: [],
      enterprises: [],
      dataEnterprises: [],
      barcodeValue: '123234345345',
      nextTicket: 0,
      rowsSelected: [],
      providers: [],
      providerSelected: null,
      // ── Anchos por refKey ──────────────────────────────────────
      columnWidths: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    selected (newValue, oldValue) {
      this.getSelectedEnterprises()
    },
    // Cuando cambia showEnterprises, re-adjuntar listeners
    showEnterprises (val) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (!val) {
            // Grid general
            this.attachResizeListener('grid', 'grid')
            this.restoreColumnWidths('grid')
          } else {
            // Grids por empresa
            this.enterprises.forEach(enterprise => {
              const refKey = `grid${enterprise.id}`
              this.attachResizeListener(refKey, refKey)
              this.restoreColumnWidths(refKey)
            })
          }
        }, 200)
      })
    }
  },
  methods: {

    // ─── Tab change ───────────────────────────────────────────────
    onTabChange (index) {
      this.$nextTick(() => {
        const enterprise = this.enterprises[index]
        if (!enterprise) return
        const refKey = this.showEnterprises ? `grid${enterprise.id}` : 'grid'
        setTimeout(() => {
          this.attachResizeListener(refKey, refKey)
          this.restoreColumnWidths(refKey)
        }, 150)
      })
    },

    // ─── Resize: adjuntar listener por refKey ─────────────────────
    // refKey: nombre del ref (ej: 'grid', 'grid5', 'grid12')
    // storageKey: clave para guardar en columnWidths
    attachResizeListener (refKey, storageKey) {
      // vue-excel-editor en array de refs usa [0], en ref simple es el objeto directo
      const refRaw = this.$refs[refKey]
      if (!refRaw) return
      const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw
      if (!ref) return

      const editorEl = ref.$el
      if (!editorEl) return
      if (editorEl._resizeListenerAttached) return
      editorEl._resizeListenerAttached = true

      const originalColSepMouseUp = ref.colSepMouseUp.bind(ref)
      ref.colSepMouseUp = (...args) => {
        originalColSepMouseUp(...args)

        this.$nextTick(() => {
          setTimeout(() => {
            const headers = editorEl.querySelectorAll('thead tr th')
            const dataHeaders = Array.from(headers).slice(1)

            this.columnWidths[storageKey] = ref.$data.fields.map((field, i) => ({
              name: field.name,
              width: dataHeaders[i] ? (dataHeaders[i].style.width || dataHeaders[i].offsetWidth + 'px') : field.width
            }))
            console.log(`✅ Anchos guardados [${storageKey}]:`, this.columnWidths[storageKey])

            this.restoreColumnWidths(storageKey)
          }, 0)
        })
      }

      const originalColSepMouseMove = ref.colSepMouseMove.bind(ref)
      ref.colSepMouseMove = (...args) => {
        originalColSepMouseMove(...args)
      }
    },

    restoreColumnWidths (storageKey) {
      if (!this.columnWidths[storageKey] || !this.columnWidths[storageKey].length) return
      setTimeout(() => {
        const refRaw = this.$refs[storageKey]
        if (!refRaw) return
        const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw
        if (!ref || !ref.$data.fields) return

        this.columnWidths[storageKey].forEach(saved => {
          const fieldIndex = ref.$data.fields.findIndex(f => f.name === saved.name)
          if (fieldIndex !== -1 && saved.width) {
            ref.$set(ref.$data.fields, fieldIndex, {
              ...ref.$data.fields[fieldIndex],
              width: saved.width
            })
          }
        })
        console.log(`✅ Anchos restaurados [${storageKey}]`)
      }, 50)
    },

    // ─── Export ───────────────────────────────────────────────────
    exportAsExcel (i) {
      const format = 'xlsx'
      const exportSelectedOnly = true
      const filename = this.nameMarca + ' - ' + moment().format('YYYY-MM-DD')
      const refRaw = this.$refs[i]
      const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw
      ref.exportTable(format, exportSelectedOnly, filename)
    },
    exportAsCsv (i) {
      const format = 'csv'
      const exportSelectedOnly = true
      const filename = this.nameMarca + ' - ' + moment().format('YYYY-MM-DD')
      const refRaw = this.$refs[i]
      const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw
      ref.exportTable(format, exportSelectedOnly, filename)
    },

    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },

    // ─── Estilos ──────────────────────────────────────────────────
    mystyle (rec, col) {
      if (col.name === 'catalogo') return { 'background-color': 'rgb(255 0 0 / 54%)' }
      else if (col.name === 'marca') return { background: '#ffb3077a' }
      else if (col.name === 'precio') return { background: 'rgb(239 89 157 / 60%)' }
      else if (col.name === 'venta') return { background: 'rgb(239 89 157 / 40%)' }
      else if (col.name === 'costo_tienda') return { background: 'rgb(239 89 157 / 40%)' }
      else if (col.name === 'porcentaje_descuento') return { background: 'rgb(56 166 210)' }
      else if (col.name === 'porcentaje_descuento_nosotros') return { background: 'rgb(56 166 210)' }
      else if (col.name === 'descuento') return { background: 'rgb(56 166 210 / 50%)' }
      else if (col.name === 'fullname' || col.name === 'id_client') return { background: '#28a7458c' }
      else if (col.name === 'cantidad' || col.name === 'pagina' || col.name === 'comentario') return { background: '#c146f078' }
      else if (col.name === 'delivery_date') return { background: '#53a9ffa1' }
      else return { 'background-color': 'white' }
    },

    onSort (...args) {
      const x = args.sort((a, b) => {
        if (a.user < b.user) return 1
        if (a.user > b.user) return -1
        return 0
      })
      this.dataEnterprises[args[0].empresa] = x
    },

    // ─── Carga de datos ───────────────────────────────────────────
    async loadItems (marca, enterprise) {
      try {
        this.jsondata = []
        const items = {
          status: 8,
          provider_id: marca.id_provider,
          enterprise_id: enterprise.id
        }
        const response = await axiosAdelaService.post('/getOrders', items)
        const xxd = []
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (response.data.totalRecords > 0) {
            let costoXD = 0
            for (const key in response.data.rows) {
              response.data.rows[key].orders.forEach((element) => {
                costoXD += parseFloat(element.costo_tienda)
                element.provider_id = marca.id_provider
                element.precio = parseFloat(element.precio).toFixed(2)
                element.descuento = parseFloat(element.descuento).toFixed(2)
                element.venta = parseFloat(element.venta).toFixed(2)
                this.jsondata.push(element)
                xxd.push(element)
              })
            }
            this.generalCost = costoXD
          }
          return xxd
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },

    async confirmChangeProvider () {
      this.rowsSelected = this.$refs.grid[0].getSelectedRecords()
      this.$modal.show('providerCahnge')
    },

    async confirmationDialog (type) {
      let msg = ''
      let functionName = ''
      switch (type) {
        case 'cargarCompras':
          functionName = 'confirmPurchase'
          msg = '<div class="text-center"><h4>Por favor Confirme que desea realizar la carga de esta compra.</h4><br> <h6><span style="color: red">Tome en cuenta que se realizara la carga de las empresas o sucursales afectadas.</span></h6></div>'
          break
        case 'save':
          functionName = 'updateOrders'
          msg = '<div class="text-center"><h4>Por favor Confirme que desea guardar los cambios efectuados</h4></div>'
          break
        default:
          break
      }
      this.$dialog.confirm(msg)
        .then(async () => {
          const info = []
          for (let index = 0; index < this.enterprises.length; index++) {
            if (type === 'cargarCompras') {
              functionName = 'confirmPurchase'
              const datos = this.dataEnterprises[this.enterprises[index].id]
              const items = []
              for (let i = 0; i < datos.length; i++) {
                if (parseFloat(datos[i].precio) > 0) {
                  datos[i].status = 1
                  items.push(datos[i])
                }
              }
              info.rows = items
              info.cargarCompras = true
              info.userId = this.user.userId
              info.enterpriseId = this.user.enterprise_id
            } else {
              info.rows = this.dataEnterprises[this.enterprises[index].id]
              info.cargarCompras = false
            }
            if (info.rows.length > 0) {
              await this.save(functionName, info)
            } else {
              this.$toastedPush({
                message: 'No hay elementos a guardar, por favor verifique sus datos..',
                type: 'error'
              })
            }
          }
          if (type === 'cargarCompras' && info.length > 0) {
            this.cargarCompras(info)
          }
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },

    async setFaltantes (ref) {
      const refRaw = this.$refs[ref]
      const refEl = Array.isArray(refRaw) ? refRaw[0] : refRaw
      const data = refEl.getSelectedRecords()
      if (data.length > 0) {
        this.$dialog.confirm('<div class="text-center"><h4>Por favor Confirme que los productos seleccionados son faltantes</h4></div>')
          .then(async () => {
            const response = await axiosAdelaService.post('/updateOrderFaltante', { data })
            if (response.status === 200 && response.data) {
              await this.getOrdersForEnterprises()
              this.$toastedPush({ message: 'Se cambio es estatus del pedido a Faltantes.', type: 'success' })
            }
          })
          .catch((err) => { console.log(err) })
      } else {
        this.$toastedPush({ message: 'No hay elementos a guardar, por favor seleccione al menos un elemento', type: 'error' })
      }
    },

    async deleteRegister (ref) {
      const refRaw = this.$refs[ref]
      const refEl = Array.isArray(refRaw) ? refRaw[0] : refRaw
      const data = refEl.getSelectedRecords()
      if (data.length > 0) {
        this.$dialog.confirm(`
          <div class="text-center"><h4>Por favor Confirme que los productos seleccionados seran eliminados</h4></div>
          <div class="row text-center mt-4"><p style="color:red">Esta acción es irreversible...</p></div>
        `)
          .then(async () => {
            const response = await axiosAdelaService.post('/deleteOrders', { data })
            if (response.status === 200 && response.data) {
              await this.getSelectedEnterprises()
              this.$toastedPush({ message: 'Se eliminaron los registros...', type: 'success' })
            }
          })
          .catch((err) => { console.log(err) })
      } else {
        this.$toastedPush({ message: 'No hay elementos a guardar, por favor seleccione al menos un elemento', type: 'error' })
      }
    },

    async save (functionName, data) {
      const items = {
        id_provider: this.id_provider,
        data: data.rows,
        cargarCompras: data.cargarCompras,
        enterprise: this.user.enterprise_id,
        user_id: this.user.user_admin_id,
        buyDay: this.today
      }
      const response = await axiosAdelaService.post(`/${functionName}`, items)
      if (response.status === 200) {
        if (response.data.addInventory !== undefined) {
          this.$router.push({ name: 'labelsOrders', params: data })
        }
        this.$toastedPush({ message: 'Se actualizaron las ordenes seleccionadas.', type: 'success' })
        this.getOrdersForEnterprises()
      }
    },

    // ─── Cálculos de precios ──────────────────────────────────────
    changeDiscount (...args) {
      const costo = args[2].precio
      const porcentageDescuento = args[0]
      const descuentoPesos = costo * (porcentageDescuento / 100)
      args[2].descuento = descuentoPesos.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
    },
    changeDiscountAbout (...args) {
      const costo = args[2].precio
      const porcentageDescuento = args[0]
      const descuentoPesos = costo * (porcentageDescuento / 100)
      args[2].costo_tienda = (costo - descuentoPesos).toFixed(2)
      args[2].porcentaje_descuento_nosotros = parseFloat(args[0])
      this.calculeGeneralCost()
    },
    changeCost (...args) {
      const costo = args[0]
      const porcentageDescuento = args[2].porcentaje_descuento
      const descuentoPesos = costo * (porcentageDescuento / 100)
      args[2].descuento = descuentoPesos.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
      args[2].precio = parseFloat(args[0]).toFixed(2)
      const descuentoTienda = parseFloat(args[2].porcentaje_descuento_nosotros)
      const costoTienda = costo * (descuentoTienda / 100)
      args[2].descuento_nosotros = costoTienda.toFixed(2)
      args[2].costo_tienda = costo - costoTienda
      this.calculeGeneralCost()
    },
    changeDiscountMoney (...args) {
      const descuentoPesos = parseFloat(args[0]).toFixed(2)
      const costo = args[2].precio
      const porcentageDescuento = (descuentoPesos * 100) / costo
      args[2].porcentaje_descuento = porcentageDescuento.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
    },
    changeClientPrice (...args) {
      const precioVenta = parseFloat(args[0])
      const porcentageDescuento = parseFloat(args[2].porcentaje_descuento)
      const costo = precioVenta / (1 - (porcentageDescuento / 100))
      const porcentageDescuentoPesos = costo * (porcentageDescuento / 100)
      args[2].precio = costo.toFixed(2)
      args[2].descuento = porcentageDescuentoPesos.toFixed(2)
      this.calculeGeneralCost()
    },
    async changeCostoTienda (...args) {
      const costoTienda = parseFloat(args[0])
      const descuentoAbout = parseFloat(args[2].porcentaje_descuento_nosotros)
      const descuentoNosotros = costoTienda * (descuentoAbout / 100)
      const precioCliente = parseFloat(costoTienda + (costoTienda * (descuentoAbout / 100)))
      const porcentageDescuento = args[2].porcentaje_descuento
      const descuentoPesos = precioCliente * (porcentageDescuento / 100)
      args[2].descuento_nosotros = descuentoNosotros.toFixed(2)
      args[2].descuento = descuentoPesos.toFixed(2)
      args[2].venta = (precioCliente - descuentoPesos).toFixed(2)
      args[2].precio = precioCliente.toFixed(2)
      args[2].costo_tienda = parseFloat(args[0])
      await this.calculeGeneralCost()
    },
    async changeClient (...args) {
      const items = { key: args[0], id_empresa: this.user.enterprise_id }
      const response = await axiosAdelaService.post('/searchClients', items)
      if (response.status === 200) {
        args[2].id_client = response.data.id_client
        args[2].fullname = response.data.fullname
      }
    },
    async calculeGeneralCost () {
      let precio = 0
      this.dataEnterprises.forEach(element => {
        element.forEach(orders => {
          precio += parseFloat(orders.costo_tienda)
        })
      })
      this.generalCost = precio.toFixed(2)
    },
    async cargarCompras (data) {
      const items = {
        function: 'cargarCompras',
        id_empresa: this.user.enterprise_id,
        id_user: this.user.user_admin_id,
        quantity_products: data.length,
        amount: parseFloat(this.generalCost),
        data: data
      }
      const params = await this.toFormData(items)
      const response = await axiosAdelaService.post('', params)
      if (response.status === 200 && response.data) {
        this.$toastedPush({ message: 'Se cargo la compra correctamente', type: 'success' })
      }
    },

    // ─── Empresas ─────────────────────────────────────────────────
    async getEnterprises () {
      const response = await axiosAdelaService.post('/getEnterprises')
      if (response.status === 200) {
        response.data.rows.forEach(element => {
          this.options.push({ text: element.name, value: element.id })
        })
      }
    },
    async getSelectedEnterprises () {
      let string = ''
      this.enterprises = []
      for (let i = 0; i < this.selected.length; i++) {
        string += this.selected[i] + ', '
      }
      string = string.substring(0, string.length - 2)
      const response = await axiosAdelaService.post('/getEnterprisesSelected', { data: string })
      if (response.status === 200) {
        response.data.rows.forEach(element => {
          this.enterprises.push(element)
        })
        this.getOrdersForEnterprises()
      }
    },
    async getOrdersForEnterprises () {
      this.generalCost = 0
      for (let index = 0; index < this.enterprises.length; index++) {
        this.dataEnterprises[this.enterprises[index].id] = []
        const arreglo = await this.loadItems(this.$route.params, this.enterprises[index])
        this.dataEnterprises[this.enterprises[index].id] = arreglo

        // Adjuntar listener y restaurar anchos después de cargar cada empresa
        const refKey = `grid${this.enterprises[index].id}`
        this.$nextTick(() => {
          setTimeout(() => {
            this.attachResizeListener(refKey, refKey)
            this.restoreColumnWidths(refKey)
          }, 200)
        })
      }
      this.generalCost = this.generalCost.toFixed(2)
    },
    async copyElements (ref) {
      const refRaw = this.$refs[ref]
      const refEl = Array.isArray(refRaw) ? refRaw[0] : refRaw
      const data = refEl.getSelectedRecords()
      const items = {
        id_provider: this.id_provider,
        data,
        enterpriseId: this.user.enterprise_id,
        userId: this.user.user_admin_id,
        idClient: 4
      }
      const response = await axiosAdelaService.post('/duplicateOrders', items)
      if (response.status === 200) {
        this.$toastedPush({ message: 'Se actualizaron las ordenes seleccionadas.', type: 'success' })
        const shw = this.showEnterprises
        this.showEnterprises = !shw
        this.selected = []
        this.selected.push(this.user.enterprise_id)
      }
    },
    addRow (enterprise) {
      const first = this.dataEnterprises[enterprise.id][0]
      this.jsondata.push({
        id_client: '',
        fullname: '',
        marca: '',
        modelo: '',
        color: '',
        numero: '',
        precio: '',
        porcentaje_descuento: first.porcentaje_descuento,
        descuento: '',
        venta: '',
        porcentaje_descuento_nosotros: first.porcentaje_descuento_nosotros,
        costo_tienda: '',
        delivery_date: first.delivery_date,
        catalogo: 'CATALOGO',
        pagina: 0,
        comentario: '',
        cantidad: 1,
        id_provider: first.id_provider,
        status: 8
      })
    },
    async getNextTicketBuys () {
      const response = await axiosAdelaService.post('/getNextTicketBuys', { enterpriseId: this.user.enterprise_id })
      if (response.status === 200) {
        this.nextTicket = response.data.next
      }
    },
    async getProviders () {
      try {
        const response = await axiosAdelaService.post('/getProviders', {})
        if (response.status === 200) {
          this.providers = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas, por favor intentelo mas tarde')
      }
    },
    async changeProvider () {
      try {
        const request = {
          data: this.rowsSelected,
          id_provider: this.providerSelected
        }
        const response = await axiosAdelaService.post('/updateOrdersProvider', request)
        if (response.status === 200) {
          this.rowsSelected = []
          this.providerSelected = null
          await this.getOrdersForEnterprises()
          this.$modal.hide('providerCahnge')
          this.showSuccess('Cambio de proveedor completo')
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas, por favor intentelo mas tarde')
      }
    }
  },

  async mounted () {
    await this.getNextTicketBuys()
    await this.getProviders()
    this.selected.push(this.user.enterprise_id)
    await this.getEnterprises()
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}
.fontButt {
  font-size: 15px;
  margin: auto;
}
.fontIconBtn {
  font-size: 22px;
  font-weight: bold;
}
</style>
